'use strict';

var implementation = require('./implementation');

module.exports = function getPolyfill() {
	return typeof Object.entries === 'function' ? Object.entries : implementation;
};



//////////////////
// WEBPACK FOOTER
// ./~/object.entries/polyfill.js
// module id = 709
// module chunks = 168707334958949